import parameters from "../configs/parameters";
import {getCity} from "./cities";
import Cookies from "js-cookie";

const url = parameters['services'];
const basicAuth = parameters['basicAuth'];

/**
 * Gets headers for HTTP requests against our backend
 * @param token Bearer token if required (nullable)
 * @param omitContentType If true we omit the content-type header
 * @returns {*}
 */
const getHeaders = (omitContentType) => {
    const token = Cookies.get('token');
    let headers = {
        "Accept-Language": "en",
        'Brand': "null",
        // fallback to basic auth in case of missing token
        'Authorization': token ? `Bearer ${token}` : `Basic ${basicAuth}`,
        'City': getCity(),
    };

    if (localStorage.getItem('hub_code')) {
        headers['Hub-Code'] = localStorage.getItem('hub_code')
    }
    // in case we want javascript to decide which content-type to use
    if (!omitContentType) {
        return Object.assign({"Content-Type": "application/json"}, headers)
    }
    return headers;
}

export const login = data =>
    fetch(`${url}/v2/oauth/token`, {
        method: "POST",
        headers: Object.assign(getHeaders(true)),
        body: data
    })
        .then(handleErrors)
        .then(res => res.json());

export const getRiders = () =>
    fetch(`${url}/v5/rider`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

export const getRidersCheckedIn = () =>
    fetch(`${url}/v5/rider/checked-in`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

export const riderCheckIn = (data) => {
    data.hub_code = localStorage.getItem('hub_code')
    return (
        fetch(`${url}/v5/rider/check-in`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify(data)
        })
            .then(handleErrors)
            .then(res => res.json())
    )
};

export const getRider = (id) =>
    fetch(`${url}/v5/rider/check-in/${id}`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

export const getDispatches = () =>
    fetch(`${url}/v4/dispatch`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

export const getRiderAttendance = (id) =>
    fetch(`${url}/v5/rider/check-in/${id}`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

export const getRiderDetails = (id) =>
    fetch(`${url}/v5/rider/${id}`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

export const getHubs = () =>
    fetch(`${url}/v5/rider/hubs`, {
        method: "GET",
        headers: getHeaders()
    })
        .then(handleErrors)
        .then(res => res.json());

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}



// WEBPACK FOOTER //
// ./src/services/api.js